import React, { forwardRef } from 'react';

interface PhoneInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: string;
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
    ({ className, onChange, value, error, ...props }, ref) => {

        // Ensure value starts with +55
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            let inputValue = e.target.value;

            // If user clears input, reset to +55
            if (inputValue === '' || inputValue === '+') {
                inputValue = '+55 ';
            }

            // If user tries to delete +55, prevent it (simple check)
            if (!inputValue.startsWith('+55')) {
                // Try to fix it if they typed useful numbers
                const numbers = inputValue.replace(/\D/g, '');
                inputValue = `+55 ${numbers}`;
            }

            // Call original onChange with modified event
            if (onChange) {
                e.target.value = inputValue;
                onChange(e);
            }
        };

        return (
            <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none border-r border-gray-200 pr-3 my-1">
                    {/* Brazil Flag SVG */}
                    <svg className="w-6 h-4" viewBox="0 0 640 480">
                        <filter id="a">
                            <feColorMatrix type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                        </filter>
                        <path fill="#009c3b" d="M0 0h640v480H0z" />
                        <path fill="#fddf00" d="M320 62.4L553.6 240 320 417.6 86.4 240z" />
                        <circle cx="320" cy="240" r="81.6" fill="#002776" />
                        <path fill="#fff" fillRule="evenodd" d="M320 230.4c-38.4 0-72 19.2-86.4 48 38.4 0 72-19.2 86.4-48z" />
                        <path fill="#fff" fillRule="evenodd" d="M320 230.4c-38.4 0-72 19.2-86.4 48 38.4 0 72-19.2 86.4-48z" />
                    </svg>
                    <span className="text-gray-500 text-sm ml-2 hidden"></span>
                </div>
                <input
                    ref={ref}
                    type="tel"
                    className={`input-field pl-20 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`}
                    onChange={handleChange}
                    value={value}
                    {...props}
                />
                {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
            </div>
        );
    }
);

PhoneInput.displayName = 'PhoneInput';
